import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Observable, map } from "rxjs";
import { IActionOdataResult } from "../models/interfaces/action-result.interface";
import { IParamObj, IParamQuery } from "../models/interfaces/param-query.interface";
import { ITravelLocation, ITravelLocationType } from "../models/interfaces/travel.interface";

@Injectable({
    providedIn: 'root'
})
export class TravelLocationService {
    constructor(private http: HttpClient) { }
    /**
     * Returns an array of event types based on http query params
     */
    public get(params?: IParamObj): Observable<Array<ITravelLocation>> {
        const paramQuery: IParamQuery = (params) ? { params: params } : null;
        return this.getTravelLocations(paramQuery).pipe(map((result) => result.value as Array<ITravelLocation>));
    }

    private getTravelLocations(paramQuery: IParamQuery): Observable<IActionOdataResult> {
        const httpParams = (paramQuery) ? paramQuery : {};
        return this.http.get<IActionOdataResult>(environment.apiBaseURL + 'odata/TravelLocations', httpParams);
    }
}